import { aroFetch } from "../aroApi";
import {
  CertificateListItem,
  CertificateListResponse,
  CertificateSearchParams,
  CertificateTypeListResponse,
} from "../../types/aro";

export async function fetchCertificates(params: CertificateSearchParams): Promise<CertificateListResponse> {
  const qs = new URLSearchParams();
  if (params.person_id)                                             qs.set("person_id",           params.person_id);
  if (params.person_name)                                           qs.set("person_name",         params.person_name);
  if (params.person_email)                                          qs.set("person_email",        params.person_email);
  if (params.event_id)                                              qs.set("event_id",            params.event_id);
  if (params.certificate_type_id)                                   qs.set("certificate_type_id", params.certificate_type_id);
  if (params.certificate_name)                                      qs.set("certificate_name",    params.certificate_name);
  if (params.issuer_company_name)                                   qs.set("issuer_company_name", params.issuer_company_name);
  if (params.level && params.level !== "all")                       qs.set("level",               params.level);
  qs.set("limit",  String(params.limit  ?? 50));
  qs.set("offset", String(params.offset ?? 0));
  return aroFetch<CertificateListResponse>(`/api/certificates?${qs.toString()}`);
}

export async function fetchCertificateById(id: string | number): Promise<CertificateListItem> {
  return aroFetch<CertificateListItem>(`/api/certificates/${id}`);
}

/** Certificate types (optionally one issuer's) plus the list of issuers. */
export async function fetchCertificateTypes(issuer_company_name?: string): Promise<CertificateTypeListResponse> {
  const qs = issuer_company_name ? `?issuer_company_name=${encodeURIComponent(issuer_company_name)}` : "";
  return aroFetch<CertificateTypeListResponse>(`/api/certificate-types${qs}`);
}

/** Only these facts are editable; credential ID and certificate type change through a re-upload. */
export interface CertificatePatch {
  changed_by:       string;
  event_id?:        number | null;
  company_at_time?: string | null;
  credential_url?:  string | null;
}

export async function updateCertificate(cert_id: string | number, body: CertificatePatch): Promise<CertificateListItem> {
  return aroFetch<CertificateListItem>(`/api/certificates/${cert_id}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}
